import { Component, Input } from "@angular/core"
import { CardInfo, UserCardAssets } from "@app/shared/interfaces/user-card"
import { LexTranslateService } from "@app/core/services/lex-translate.service"
@Component({
  selector: "seb-access-card",
  templateUrl: "./access-card.component.html",
  styleUrls: ["./access-card.component.css"],
})
export class AccessCardComponent {
  @Input() cardInfo: CardInfo
  @Input() userCardAssets: UserCardAssets

  constructor(public lextranslate: LexTranslateService) {}

  ngOnChanges() {
    if (this.cardInfo) {
      this.cardInfo = { ...this.cardInfo }
    }
  }
}
